var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgHome1Tr({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 360,
    height: 439,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply",
      stroke: "#e6abab",
      strokeOpacity: 1
    }
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFBABA",
    strokeWidth: 6,
    d: "M30.51 133.947C-.405 110.787-6.155 65.903 17.977 33.649 42.108 1.396 86.767-5.726 117.684 17.434c7.938 5.947 10.8 10.393 11.276 13.883.46 3.366-1.175 6.882-5.259 11.422-2.98 3.312-6.861 6.75-11.339 10.715-1.658 1.469-3.399 3.01-5.206 4.645-6.577 5.95-13.781 12.926-20.22 21.531-6.43 8.596-11.43 17.925-15.78 26.569-.965 1.919-1.895 3.795-2.799 5.619-3.217 6.493-6.11 12.329-9.142 17.104-3.914 6.163-7.605 9.783-11.69 10.872-3.935 1.049-9.234-.019-17.014-5.847Z",
    style: {
      stroke: "#e6abab",
      strokeOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C1F9A2",
    d: "M312.502 365.153c-8.94 14.533-18.708 30.018-36.864 42.292-49.601 33.533-132.455 57.6-151.217-27.416-8.523-28.198 34.507-57.112 48.267-74.897 15.836-20.467 33.465-43.443 10.258-64.418-11.942-10.794-29.228-18.717-37.611-32.818-12.079-20.317-17.042-36.772-19.03-60.942-3.842-46.726 60.182-78.178 100.429-65.3 70.451 22.541 102.466 96.285 108.552 163.998 3.72 41.397-.722 83.637-22.784 119.501Z",
    style: {
      fill: "#c1e4d1",
      fillOpacity: 1
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#0E0E2C",
    strokeLinecap: "square",
    strokeWidth: 6,
    d: "M361.908 223.518c-43.54-21.053-91.241 54.296-109.445 83.952-17.716 28.91-33.136 59.928-69.659 66.086C150.481 378.934 97.78 363.009 79 400.391"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgHome1Tr);
export default __webpack_public_path__ + "static/media/bg_home1_tr.1fc0bfe8b145fe39b48fd69cc99d50ff.svg";
export { ForwardRef as ReactComponent };